// AddEventModal.js
import React, { useState, useMemo } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Label,
    Input,
    Row,
    Col,
    InputGroup,
    InputGroupText
} from "reactstrap";
import Select from "react-select";
import PropTypes from "prop-types";
import { addEvent } from "helpers/fakebackend_helper";

const AddEventModal = ({ isOpen, toggle, locations, handleSave }) => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const today = new Date().toISOString().slice(0, 10);

    const [eventName, setEventName] = useState("");
    const [eventNote, setEventNote] = useState("");
    const [eventDate, setEventDate] = useState(today);
    const [invoiceAmount, setInvoiceAmount] = useState(0);
    const [laborCost, setLaborCost] = useState(0);
    const [nonLaborCost, setNonLaborCost] = useState(0);
    const [selectedLocation, setSelectedLocation] = useState(null);

    // location options
    const locationOptions = useMemo(() => {
        return (locations || []).map((loc) => ({
            value: loc.id,
            label: loc.location_name,
            data: loc
        }));
    }, [locations]);

    const resetForm = () => {
        setEventName("");
        setEventNote("");
        setEventDate(today);
        setInvoiceAmount(0);
        setLaborCost(0);
        setNonLaborCost(0);
        setSelectedLocation(null);
    };

    const handleAdd = async () => {
        const payload = {
            event_name: eventName,
            event_note: eventNote,
            event_date: eventDate,
            invoice_amount: parseFloat(invoiceAmount) || 0,
            labor_cost: parseFloat(laborCost) || 0,
            non_labor_cost: parseFloat(nonLaborCost) || 0,
            location_id: selectedLocation?.value || null
        };

        await addEvent(user.token, payload);
        handleSave();
        resetForm();
        toggle();
    };

    const handleCancel = () => {
        resetForm();
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} size="lg">
            <ModalHeader toggle={handleCancel}>Add Event</ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={12}>
                        <Label>Event Name</Label>
                        <Input
                            type="text"
                            value={eventName}
                            onChange={(e) => setEventName(e.target.value)}
                        />
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col md={6}>
                        <Label>Event Date</Label>
                        <Input
                            type="date"
                            value={eventDate}
                            onChange={(e) => setEventDate(e.target.value)}
                        />
                    </Col>
                    <Col md={6}>
                        <Label>Location (optional)</Label>
                        <Select
                            options={locationOptions}
                            value={selectedLocation}
                            onChange={(opt) => setSelectedLocation(opt)}
                            isClearable
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    backgroundColor: "white",
                                    zIndex: 9999
                                })
                            }}
                        />
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col md={4}>
                        <Label>Invoice Amount</Label>
                        <InputGroup>
                            <InputGroupText>$</InputGroupText>
                            <Input
                                type="number"
                                value={invoiceAmount}
                                onChange={(e) => setInvoiceAmount(e.target.value)}
                            />
                        </InputGroup>
                    </Col>
                    <Col md={4}>
                        <Label>Labor Cost</Label>
                        <InputGroup>
                            <InputGroupText>$</InputGroupText>
                            <Input
                                type="number"
                                value={laborCost}
                                onChange={(e) => setLaborCost(e.target.value)}
                            />
                        </InputGroup>
                    </Col>
                    <Col md={4}>
                        <Label>Non-Labor Cost</Label>
                        <InputGroup>
                            <InputGroupText>$</InputGroupText>
                            <Input
                                type="number"
                                value={nonLaborCost}
                                onChange={(e) => setNonLaborCost(e.target.value)}
                            />
                        </InputGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <Label>Event Note</Label>
                        <Input
                            type="textarea"
                            value={eventNote}
                            onChange={(e) => setEventNote(e.target.value)}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleAdd}>
                    Add
                </Button>
                <Button color="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

AddEventModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    locations: PropTypes.array,
    handleSave: PropTypes.func.isRequired
};

export default AddEventModal;
